import { render, staticRenderFns } from "./UnsubscriberEmailPage.vue?vue&type=template&id=b2e3fa80&scoped=true&"
import script from "./UnsubscriberEmailPage.vue?vue&type=script&lang=js&"
export * from "./UnsubscriberEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscriberEmailPage.vue?vue&type=style&index=0&id=b2e3fa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3fa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e3fa80')) {
      api.createRecord('b2e3fa80', component.options)
    } else {
      api.reload('b2e3fa80', component.options)
    }
    module.hot.accept("./UnsubscriberEmailPage.vue?vue&type=template&id=b2e3fa80&scoped=true&", function () {
      api.rerender('b2e3fa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UnsubscriberEmailPage.vue"
export default component.exports